import axios from '@/libs/api.request'

export const GetDataMachine = (data) => {
  return axios.request({
    url: '/print/data/machine',
    params: data,
    method: 'get'
  })
}
export const GetDataCompany = (data) => {
  return axios.request({
    url: '/print/data/company',
    params: data,
    method: 'get'
  })
}
export const GetDataAgent = (data) => {
  return axios.request({
    url: '/print/data/agent',
    params: data,
    method: 'get'
  })
}
export const GetDataSite = (data) => {
  return axios.request({
    url: '/print/data/site',
    params: data,
    method: 'get'
  })
}
export const GetDataStatistics = (data) => {
  return axios.request({
    url: '/print/data/statistics',
    params: data,
    method: 'get'
  })
}
export const GetSettle = (data) => {
  return axios.request({
    url: '/print/data/settle',
    params: data,
    method: 'get'
  })
}
export const GetSettleDetail = (data) => {
  return axios.request({
    url: '/print/data/settle/detail',
    params: data,
    method: 'get'
  })
}
export const GetSettleAndDetail = (data) => {
  return axios.request({
    url: '/print/data/settle/and/detail',
    params: data,
    method: 'get'
  })
}
export const GetSettleReturnJob = (data) => {
  return axios.request({
    url: '/print/data/settle/return',
    params: data,
    method: 'get'
  })
}
export const GetConvert = (data) => {
  return axios.request({
    url: '/print/convert',
    params: data,
    method: 'get'
  })
}
export const SaveConvert = (data) => {
  return axios.request({
    url: '/print/convert',
    data: data,
    method: 'post'
  })
}
